import IcoMoon from 'react-icomoon';

import { ACTIVITY_TYPES } from '@/v2/domains/Activities/constants/types';

import iconSet from '../../../../../../fonts/icomoon/selection.json';

const glyphAliases: Record<string, string> = {
  [ACTIVITY_TYPES.external]: 'video',
  [ACTIVITY_TYPES.storyWithQuestions]: 'shortStory',
};

type ActivityTypeGlyphProps = {
  type: string;
  size: number | string;
  color: string;
};

export default function ActivityTypeGlyph({
  type,
  size,
  color,
}: ActivityTypeGlyphProps) {
  return (
    <IcoMoon
      iconSet={iconSet}
      icon={glyphAliases[type] ?? type}
      size={size}
      color={color}
    />
  );
}
